import React from 'react';
import introvideo from '../../assets/intro-video.png';
import YouTube from 'react-youtube';

function MyVideo(props) {
    const _onReady = (event) => {
        // access to player in all event handlers via event.target
        event.target.pauseVideo();
    }
    const opts = {
        height: '170',
        width: '298',
        playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 1,
        },
    };
    return (
    <div>
        <div className="card mg-b-0 ht-250" >
        <div className="card-header">
            <div className="card-header-left">
                <h5>Introductory Video</h5>
            </div>
            <div className="card-header-right">
                <ul className="row" >                        
                    <li><i className="far fa-edit" ></i></li>
                </ul>                    
            </div>
        </div>  
        <div className="">
            <YouTube videoId="G7pJrt5haRs" opts={opts} onReady={_onReady} />
        </div>
            
                </div>
    </div>
        
    );
  }

export default MyVideo